module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"automatePlatform":"Automate your platform","importTrades":"Import historic trades"},"es":{"automatePlatform":"Automatiza tu plataforma","importTrades":"Importa trades históricos"}}')
  delete Component.options._Ctor
}
